module.exports = __webpack_public_path__ + "media/assets/fonts/Verdana-Bold-c4e1b53d02ea7938d5bc94cbf8e38b15.ttf";